import { config, handleResponse } from '../../_helpers';

export const outboundServices = {
    //atw
    getBookingForATW,
    updateBookingATW,
    searchBookingATW,
    //cts
    getBookingForCBS,
    loadCts,
    getCTS,
    getBookingForCTS,
    getBookingForCTSTandem,
    createBookingCts,
    updateCTSNum,
    deleteByCTSNum,

    // waybill
    loadWayBill,
    getWayBill,
    getBookingForWayBill,
    getBookingForWayBillTandem,
    createWayBill,
    updateWayBillRef,
    deleteByWayBill,
    shipperOwnContainerCts,
    updateShipperOwnCVCts,
    generateExemptionCharge,

    //build up
    getWayBIllBuildUp,// outbound build up list
    getWayBillByVoyageNum, //build-up
    isWithPermit,

    //loadlist
    groupWayBillbyRelease,
    updateLoadListReleaseType,
    deleteLoadListByRelease,
    createLoadList,
    getWayBillReleaseType,
    acknowledgeRelease,
    updateLoadList,

    //tallysheet
    readListTallySheetByVoyageNum, //get tallysheet by voyage num
    getTallySheetCode,
    getListForTallySheet, //create tally sheet
    createTallySheet,
    updateTallySheet,
    createFinalTallySheet,
    updateFinalTallySheet,
    deleteByTallySheet,
    getVoyageLoadingReport,
    getVoyageLoadingReportTallysheet,

    //stowage
    getListVoyageWithStowagePlan,
    getVoyageStowagePlan, // get for create
    createStowagePlan,
    getStowagePlanCode,
    deleteByStowagePlanCode,
    updateStowagePlan,
    getVoyageNumPrintLoaded, // get for stowage plan printout

    //loading confirmation
    getLoadingConfirmationByVoyageNum,
    SentUnsent,

    //not use
    getAllCTS,
    moveWayBillRef,

    // Voyage List
    getVoyageBuildUp,
    getVoyageLoadList,
    getVoyageTallySheetList,
    getVoyageStowagePlanList,
    getVoyageLoadingConfirmationList,
    getVoyageWayBill,
    getVoyageForReguidingList,
    getVoyageCroAccounting,

    // Reguide
    getReguideVoyage,
    getVoyageScheduleForReguiding,
    changeVessel,
    voyageTransfer,

    // CRO Accounting
    getWayBIllWithDemmurage,
    getWayBIllCROAccounting,
    getWayBIllRefCROAccounting,
    updateCroAccounting,

    getPrevVoyage,

    // Dispatch Module
    getDispacthList,
    updateOutDispatchList,
    sendOutDispatchList,
    archiveOutDispatchList,
    readArchiveOutDispatchList,

    searchSalesInvoice,
}
function searchSalesInvoice(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/OutBound/searchSalesInvoice`, requestOptions).then(handleResponse);
}

// Dispatch Module
function getDispacthList(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/OutBound/getDispacthList`, requestOptions).then(handleResponse);
}
function updateOutDispatchList(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/OutBound/updateOutDispatchList`, requestOptions).then(handleResponse);
}
function sendOutDispatchList(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/OutBound/sendOutDispatchList`, requestOptions).then(handleResponse);
}
function archiveOutDispatchList(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/OutBound/archiveOutDispatchList`, requestOptions).then(handleResponse);
}
function readArchiveOutDispatchList(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/OutBound/readArchiveOutDispatchList`, requestOptions).then(handleResponse);
}

//atw
function getBookingForATW(bookingRef, branchCode) {
    const requestOptions = {
        method: 'GET'
    };
    // return fetch(`${config.apiUrl}/OutBound/getVanOutATW/${bookingRef}?userBranch=${branchCode}`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/OutBound/getVanOutATWTransactionRef/${bookingRef}?userBranch=${branchCode}`, requestOptions).then(handleResponse);
}
function searchBookingATW(search, branchCode) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(search),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    // return fetch(`${config.apiUrl}/OutBound/searchBookingATW/${branchCode}`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/OutBound/searchBookingATWV1/${branchCode}`, requestOptions).then(handleResponse);
}
function updateBookingATW(payload) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/OutBound/updateBookingATW`, requestOptions).then(handleResponse);
}
//end of atw
//cts
function getBookingForCBS(bookingRef, branchCode) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/OutBound/getBookingForCBS/${bookingRef}?userBranch=${branchCode}`, requestOptions).then(handleResponse);
}
function loadCts(skip, take, filter, search, branch) {
    const requestOptions = {
        method: 'GET'
    };
    // if (filter && search) return fetch(`${config.apiUrl}/OutBound/loadCts/?skip=${skip}&take=${take}&filter=${filter}&search=${search}&userBranch=${branch}`, requestOptions).then(handleResponse);
    // else return fetch(`${config.apiUrl}/OutBound/loadCts/?skip=${skip}&take=${take}&userBranch=${branch}`, requestOptions).then(handleResponse);
    if (filter && search) return fetch(`${config.apiUrl}/OutBound/loadCtsHeaderV1/?skip=${skip}&take=${take}&filter=${filter}&search=${search}&userBranch=${branch}`, requestOptions).then(handleResponse);
    else return fetch(`${config.apiUrl}/OutBound/loadCtsHeaderV1/?skip=${skip}&take=${take}&userBranch=${branch}`, requestOptions).then(handleResponse);
}
function getCTS(CtsNum) {
    const requestOptions = {
        method: 'GET'
    };
    // return fetch(`${config.apiUrl}/OutBound/getCTS/${CtsNum}`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/OutBound/getCTSV1/${CtsNum}`, requestOptions).then(handleResponse);
}
function getBookingForCTSTandem(bookingRef, branch) {
    const requestOptions = {
        method: 'GET'
    };
    // return fetch(`${config.apiUrl}/OutBound/getBookingForCTSV1/${bookingRef}?userBranch=${branch}`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/OutBound/getBookingForCTSV2/${bookingRef}?userBranch=${branch}`, requestOptions).then(handleResponse);
}
function getBookingForCTS(bookingRef, branch) {
    const requestOptions = {
        method: 'GET'
    };
    // return fetch(`${config.apiUrl}/OutBound/getBookingForCTS/${bookingRef}?userBranch=${branch}`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/OutBound/getBookingForCTSV1/${bookingRef}?userBranch=${branch}`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/OutBound/getBookingForCTSV2/${bookingRef}?userBranch=${branch}`, requestOptions).then(handleResponse);
}
function createBookingCts(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    // return fetch(`${config.apiUrl}/OutBound/createBookingCtsDamageParts`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/OutBound/createBookingCtsDamagePartsV1`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/OutBound/createBookingCtsDamagePartsV2`, requestOptions).then(handleResponse);
}
function updateCTSNum(payload, CtsNum) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    // return fetch(`${config.apiUrl}/OutBound/updateCTSDamageParts/${CtsNum}`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/OutBound/updateCTSDamagePartsV1/${CtsNum}`, requestOptions).then(handleResponse);
}
function deleteByCTSNum(id) {
    const requestOptions = {
        method: 'DELETE',
        body: JSON.stringify(id),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    // return fetch(`${config.apiUrl}/OutBound/deleteByCTSNum`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/OutBound/deleteCTSDamageParts`, requestOptions).then(handleResponse);
}
//end of cts
//waybill
// function loadWayBill(voyageNum, skip, take, filter, search) {
// function loadWayBill(skip, take, filter, search, firstQuery) {
function loadWayBill(skip, take, filter, search) {
    const requestOptions = {
        method: 'GET'
    };
    // if (filter && search) return fetch(`${config.apiUrl}/OutBound/loadWayBillByHeader?skip=${skip}&take=${take}&filter=${filter}&search=${search}`, requestOptions).then(handleResponse);
    // else return fetch(`${config.apiUrl}/OutBound/loadWayBillByHeader?skip=${skip}&take=${take}`, requestOptions).then(handleResponse);
    // if (filter && search) return fetch(`${config.apiUrl}/OutBound/loadWayBillByHeaderV1?skip=${skip}&take=${take}&filter=${filter}&search=${search}&firstQuery${firstQuery}`, requestOptions).then(handleResponse);
    // else return fetch(`${config.apiUrl}/OutBound/loadWayBillByHeaderV1?skip=${skip}&take=${take}&firstQuery${firstQuery}`, requestOptions).then(handleResponse);
    if (filter && search) return fetch(`${config.apiUrl}/OutBound/loadWayBillByHeaderV1?skip=${skip}&take=${take}&filter=${filter}&search=${search}`, requestOptions).then(handleResponse);
    else return fetch(`${config.apiUrl}/OutBound/loadWayBillByHeaderV1?skip=${skip}&take=${take}`, requestOptions).then(handleResponse);
}
function getWayBill(WayBillRef) {
    const requestOptions = {
        method: 'GET'
    };
    // return fetch(`${config.apiUrl}/OutBound/getWayBillwithCtsDamage/${WayBillRef}`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/OutBound/getWayBillwithCtsDamageV1/${WayBillRef}`, requestOptions).then(handleResponse);
}
// function getBookingForWayBill(bookingRef, branch, voyageNum) {
function getBookingForWayBill(bookingRef, branch) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/OutBound/getBookingWithCharges/${bookingRef}?userBranch=${branch}`, requestOptions).then(handleResponse);
}
function getBookingForWayBillTandem(bookingRef, branch) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/OutBound/getBookingWithCharges/${bookingRef}?userBranch=${branch}`, requestOptions).then(handleResponse);
}
function createWayBill(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    // return fetch(`${config.apiUrl}/OutBound/createWayBillBookingRatePerBag`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/OutBound/createWayBillWithOpenVan`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/OutBound/createWayBillWithOpenVanV1`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/OutBound/createWayBillWithOpenVanV2`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/OutBound/createWayBillWithOpenVanV3`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/OutBound/createWayBillWithOpenVanV4`, requestOptions).then(handleResponse);
}
function updateWayBillRef(wayBillRef, payload) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    // return fetch(`${config.apiUrl}/OutBound/updateWayBillStrippingStuffing/${wayBillRef}`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/OutBound/updateWayBillWithOpenVan/${wayBillRef}`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/OutBound/updateWayBillWithOpenVanV1/${wayBillRef}`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/OutBound/updateWayBillWithOpenVanV2/${wayBillRef}`, requestOptions).then(handleResponse);
}
function deleteByWayBill(id) {
    const requestOptions = {
        method: 'DELETE',
        body: JSON.stringify(id),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/OutBound/deleteByWayBill`, requestOptions).then(handleResponse);
}
function shipperOwnContainerCts(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/OutBound/shipperOwnContainerCtsDamageParts`, requestOptions).then(handleResponse);
}
function updateShipperOwnCVCts(ctsNum, payload) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/OutBound/updateShipperOwnCtsDamageParts/${ctsNum}`, requestOptions).then(handleResponse);
}
function generateExemptionCharge(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/OutBound/generateExemptionCharge`, requestOptions).then(handleResponse);
}
//end of waybill
//build up
function getWayBIllBuildUp(voyageNUm, branch, filter) {
    const requestOptions = {
        method: 'GET'
    };
    if (branch) {
        if (filter && filter !== '') {
            // return fetch(`${config.apiUrl}/OutBound/getWayBIllBuildUp/${voyageNUm}?branch=${branch}&filter=${filter}`, requestOptions).then(handleResponse);
            // return fetch(`${config.apiUrl}/OutBound/getWayBIllBuildUpV1/${voyageNUm}?branch=${branch}&filter=${filter}`, requestOptions).then(handleResponse);
            return fetch(`${config.apiUrl}/OutBound/getWayBIllBuildUpV2/${voyageNUm}?branch=${branch}&filter=${filter}`, requestOptions).then(handleResponse);
        }
        else {
            // return fetch(`${config.apiUrl}/OutBound/getWayBIllBuildUp/${voyageNUm}?branch=${branch}`, requestOptions).then(handleResponse);
            // return fetch(`${config.apiUrl}/OutBound/getWayBIllBuildUpV1/${voyageNUm}?branch=${branch}`, requestOptions).then(handleResponse);
            return fetch(`${config.apiUrl}/OutBound/getWayBIllBuildUpV2/${voyageNUm}?branch=${branch}`, requestOptions).then(handleResponse);
        }
    }
    else {
        // return fetch(`${config.apiUrl}/OutBound/getWayBIllBuildUp/${voyageNUm}`, requestOptions).then(handleResponse);
        // return fetch(`${config.apiUrl}/OutBound/getWayBIllBuildUpV1/${voyageNUm}`, requestOptions).then(handleResponse);
        return fetch(`${config.apiUrl}/OutBound/getWayBIllBuildUpV2/${voyageNUm}`, requestOptions).then(handleResponse);
    }

}
function getWayBillByVoyageNum(voyageNum, search, branch) {
    const requestOptions = {
        method: 'GET'
    };
    // if (search) return fetch(`${config.apiUrl}/OutBound/getWayBillBookingVia/${voyageNum}?search=${search}`, requestOptions).then(handleResponse);
    // else return fetch(`${config.apiUrl}/OutBound/getWayBillBookingVia/${voyageNum}`, requestOptions).then(handleResponse);
    if (search) return fetch(`${config.apiUrl}/OutBound/getWayBillBookingVia1/${voyageNum}?search=${search}?branch=${branch}`, requestOptions).then(handleResponse);
    else return fetch(`${config.apiUrl}/OutBound/getWayBillBookingVia1/${voyageNum}?branch=${branch}`, requestOptions).then(handleResponse);
}
function isWithPermit(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/OutBound/isWithPermit`, requestOptions).then(handleResponse);
}
//end of build up
//loadlist
function groupWayBillbyRelease(voyageNUm) {
    const requestOptions = {
        method: 'GET'
    };
    
    // return fetch(`${config.apiUrl}/OutBound/groupWayBillbyRelease/${voyageNUm}`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/OutBound/groupWayBillbyReleaseV1/${voyageNUm}`, requestOptions).then(handleResponse);
}
function updateLoadListReleaseType(payload) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/OutBound/updateLoadListReleaseType`, requestOptions).then(handleResponse);
}
function deleteLoadListByRelease(payload) {
    const requestOptions = {
        method: 'DELETE',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/OutBound/deleteLoadListByRelease`, requestOptions).then(handleResponse);
}
function createLoadList(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/OutBound/createLoadList`, requestOptions).then(handleResponse);
}
function getWayBillReleaseType(voyageNum, ReleaseId, search) {
    const requestOptions = {
        method: 'GET'
    };
    // if (search) {
    //     return fetch(`${config.apiUrl}/OutBound/getWayBillReleaseType/${voyageNum}?ReleaseId=${ReleaseId}&search=${search}`, requestOptions).then(handleResponse);
    // } else {
    //     return fetch(`${config.apiUrl}/OutBound/getWayBillReleaseType/${voyageNum}?ReleaseId=${ReleaseId}`, requestOptions).then(handleResponse);
    // }
    if (search) {
        return fetch(`${config.apiUrl}/OutBound/getWayBillReleaseTypeV1/${voyageNum}?ReleaseId=${ReleaseId}&search=${search}`, requestOptions).then(handleResponse);
    } else {
        return fetch(`${config.apiUrl}/OutBound/getWayBillReleaseTypeV1/${voyageNum}?ReleaseId=${ReleaseId}`, requestOptions).then(handleResponse);
    }
}
function acknowledgeRelease(payload) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/OutBound/acknowledgeRelease`, requestOptions).then(handleResponse);
}
function updateLoadList(payload, releaseId) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/OutBound/updateLoadList/${releaseId}`, requestOptions).then(handleResponse);
}
//end of loadlist
//tallysheet
function readListTallySheetByVoyageNum(voyageNum) {
    const requestOptions = {
        method: 'GET'
    };
    // return fetch(`${config.apiUrl}/OutBound/readListTallySheetByVoyageNum/${voyageNum}`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/OutBound/readListTallySheetByVoyageNumV1/${voyageNum}`, requestOptions).then(handleResponse);
}
function getTallySheetCode(tallysheetCode) {
    const requestOptions = {
        method: 'GET'
    };
    // return fetch(`${config.apiUrl}/OutBound/getTallySheetCode/${tallysheetCode}`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/OutBound/getTallySheetCodeV1/${tallysheetCode}`, requestOptions).then(handleResponse);
}
function getListForTallySheet(voyageNUm, branch) {
    const requestOptions = {
        method: 'GET'
    };
    // return fetch(`${config.apiUrl}/OutBound/getLoadListForTallySheet/${voyageNUm}/?branch=${branch}`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/OutBound/getLoadListForTallySheet1/${voyageNUm}/?branch=${branch}`, requestOptions).then(handleResponse);
}
function createTallySheet(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    // return fetch(`${config.apiUrl}/OutBound/createTallySheet`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/OutBound/createTallySheet1`, requestOptions).then(handleResponse);
}
function updateTallySheet(payload, tallysheetCode) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/OutBound/updateTallySheet/${tallysheetCode}`, requestOptions).then(handleResponse);
}
function createFinalTallySheet(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    // return fetch(`${config.apiUrl}/OutBound/createFinalTallySheet`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/OutBound/createFinalTallySheetV1`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/OutBound/createFinalTallySheetV2`, requestOptions).then(handleResponse);
}
function updateFinalTallySheet(payload, id) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    // return fetch(`${config.apiUrl}/OutBound/updateFinalTallySheet/${id}`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/OutBound/updateFinalTallySheetV1/${id}`, requestOptions).then(handleResponse);
}
function deleteByTallySheet(id) {
    const requestOptions = {
        method: 'DELETE',
        body: JSON.stringify(id),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/OutBound/deleteByTallySheet`, requestOptions).then(handleResponse);
}
function getVoyageLoadingReport(id) {
    const requestOptions = {
        method: 'GET'
    };
    // return fetch(`${config.apiUrl}/OutBound/getVoyageLoadingReportVia/${id}`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/OutBound/getVoyageLoadingReportVia1/${id}`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/OutBound/getVoyageLoadingReportVia2/${id}`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/OutBound/getVoyageLoadingReportVia3/${id}`, requestOptions).then(handleResponse);
}
function getVoyageLoadingReportTallysheet(id) {
    const requestOptions = {
        method: 'GET'
    };
     return fetch(`${config.apiUrl}/OutBound/getVoyageLoadingReportTallysheet/${id}`, requestOptions).then(handleResponse);
}
//end of tallysheet
//stowage
function getListVoyageWithStowagePlan(voyageNUm) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/OutBound/getListVoyageWithStowagePlan/${voyageNUm}`, requestOptions).then(handleResponse);
}
function getVoyageStowagePlan(voyageNUm) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/OutBound/getVoyageStowagePlan/${voyageNUm}`, requestOptions).then(handleResponse);
}
function createStowagePlan(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/OutBound/CreateStowagePlan`, requestOptions).then(handleResponse);
}
function getStowagePlanCode(stowagePlanCode) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/OutBound/getStowagePlanCode/${stowagePlanCode}`, requestOptions).then(handleResponse);
}
function deleteByStowagePlanCode(id) {
    const requestOptions = {
        method: 'DELETE',
        body: JSON.stringify(id),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/OutBound/deleteByStowagePlanCode`, requestOptions).then(handleResponse);
}
function updateStowagePlan(payload, stowagePlanCode) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/OutBound/updateStowagePlan/${stowagePlanCode}`, requestOptions).then(handleResponse);
}
function getVoyageNumPrintLoaded(id) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/OutBound/getVoyageNumPrintLoaded/${id}`, requestOptions).then(handleResponse);
}
//end of stowage
//loading confirmation
function getLoadingConfirmationByVoyageNum(voyageNUm) {
    const requestOptions = {
        method: 'GET'
    };
    // return fetch(`${config.apiUrl}/OutBound/getLoadingConfirmationByVoyageNum/${voyageNUm}`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/OutBound/loadingConfirmationByVoyageNum/${voyageNUm}`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/OutBound/loadingConfirmationByVoyageNumVia/${voyageNUm}`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/OutBound/loadingConfirmationByVoyageNumVia1/${voyageNUm}`, requestOptions).then(handleResponse);
}
function SentUnsent(bookingRef, isSent) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(bookingRef),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/OutBound/SentUnsent/?isSent=${isSent}`, requestOptions).then(handleResponse);
}
//end of loading confirmation


//not use
function getAllCTS() {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/OutBound/getAllCTS`, requestOptions).then(handleResponse);
}
function moveWayBillRef(payload) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/OutBound/moveWayBillRef`, requestOptions).then(handleResponse);
}
//end of not use

// Voyage List
function getVoyageBuildUp(branchCode, search) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(branchCode),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    
    // if(search){
    //     return fetch(`${config.apiUrl}/OutBound/getVoyageListingBuildUpByAssignBranch?search=${search}`, requestOptions).then(handleResponse);
    // }
    // else{
    //     return fetch(`${config.apiUrl}/OutBound/getVoyageListingBuildUpByAssignBranch`, requestOptions).then(handleResponse);
    // }
    if(search){
        return fetch(`${config.apiUrl}/OutBound/getVoyageListingBuildUpByAssignBranchV1?search=${search}`, requestOptions).then(handleResponse);
    }
    else{
        return fetch(`${config.apiUrl}/OutBound/getVoyageListingBuildUpByAssignBranchV1`, requestOptions).then(handleResponse);
    }
    // const requestOptions = {
    //     method: 'GET'
    // };
    // if (branchCode) return fetch(`${config.apiUrl}/OutBound/getVoyageBuildUp?branchCode=${branchCode}`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/OutBound/getVoyageBuildUp`, requestOptions).then(handleResponse);
    // if (branchCode) {
    //     if(search){
    //         return fetch(`${config.apiUrl}/OutBound/getVoyageListingBuildUp?branchCode=${branchCode}&search=${search}`, requestOptions).then(handleResponse);
    //     }
    //     else{
    //         return fetch(`${config.apiUrl}/OutBound/getVoyageListingBuildUp?branchCode=${branchCode}`, requestOptions).then(handleResponse);
    //     }
    // }
    // else{
    //     if(search){
    //         return fetch(`${config.apiUrl}/OutBound/getVoyageListingBuildUp?search=${search}`, requestOptions).then(handleResponse);
    //     }
    //     else{
    //         return fetch(`${config.apiUrl}/OutBound/getVoyageListingBuildUp`, requestOptions).then(handleResponse);
    //     }
    // }

}
function getVoyageLoadList(branchCode, search) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(branchCode),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    // if(search){
    //     return fetch(`${config.apiUrl}/OutBound/getVoyageListingLoadListAssignBranch?search=${search}`, requestOptions).then(handleResponse);
    // }
    // else{
    //     return fetch(`${config.apiUrl}/OutBound/getVoyageListingLoadListAssignBranch`, requestOptions).then(handleResponse);
    // }
    if(search){
        return fetch(`${config.apiUrl}/OutBound/getVoyageListingLoadListAssignBranchV1?search=${search}`, requestOptions).then(handleResponse);
    }
    else{
        return fetch(`${config.apiUrl}/OutBound/getVoyageListingLoadListAssignBranchV1`, requestOptions).then(handleResponse);
    }
    // const requestOptions = {
    //     method: 'GET'
    // };
    // if (branchCode) return fetch(`${config.apiUrl}/OutBound/getVoyageLoadList?branchCode=${branchCode}`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/OutBound/getVoyageLoadList`, requestOptions).then(handleResponse);
    // if (branchCode){ 
    //     if(search){
    //         return fetch(`${config.apiUrl}/OutBound/getVoyageListingLoadList?branchCode=${branchCode}&search=${search}`, requestOptions).then(handleResponse);
    //     }
    //     else{
    //         return fetch(`${config.apiUrl}/OutBound/getVoyageListingLoadList?branchCode=${branchCode}`, requestOptions).then(handleResponse);
    //     }
    // }
    // else{
    //     if(search){
    //         return fetch(`${config.apiUrl}/OutBound/getVoyageListingLoadList?search=${search}`, requestOptions).then(handleResponse);
    //     }
    //     else{
    //         return fetch(`${config.apiUrl}/OutBound/getVoyageListingLoadList`, requestOptions).then(handleResponse);
    //     }
    // }
}
function getVoyageTallySheetList(branchCode, search) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(branchCode),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    // if(search){
    //     return fetch(`${config.apiUrl}/OutBound/getVoyageListingTallySheetAssignBranch?search=${search}`, requestOptions).then(handleResponse);
    // }
    // else{
    //     return fetch(`${config.apiUrl}/OutBound/getVoyageListingTallySheetAssignBranch`, requestOptions).then(handleResponse);
    // }
    if(search){
        return fetch(`${config.apiUrl}/OutBound/getVoyageListingTallySheetAssignBranchV1?search=${search}`, requestOptions).then(handleResponse);
    }
    else{
        return fetch(`${config.apiUrl}/OutBound/getVoyageListingTallySheetAssignBranchV1`, requestOptions).then(handleResponse);
    }
    // const requestOptions = {
    //     method: 'GET'
    // };
    // if (branchCode) return fetch(`${config.apiUrl}/OutBound/getVoyageTallySheetList?branchCode=${branchCode}`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/OutBound/getVoyageTallySheetList`, requestOptions).then(handleResponse);
    // if (branchCode) {
    //     if(search){
    //         return fetch(`${config.apiUrl}/OutBound/getVoyageListingTallySheet?branchCode=${branchCode}&search=${search}`, requestOptions).then(handleResponse);
    //     }
    //     else{
    //         return fetch(`${config.apiUrl}/OutBound/getVoyageListingTallySheet?branchCode=${branchCode}`, requestOptions).then(handleResponse);
    //     }
    // }
    // else{
    //     if(search){
    //         return fetch(`${config.apiUrl}/OutBound/getVoyageListingTallySheet?search=${search}`, requestOptions).then(handleResponse);
    //     }
    //     else{
    //         return fetch(`${config.apiUrl}/OutBound/getVoyageListingTallySheet`, requestOptions).then(handleResponse);
    //     }
    // }
}
function getVoyageStowagePlanList(branchCode, search) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(branchCode),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    // if(search){
    //     return fetch(`${config.apiUrl}/OutBound/getVoyageListingStowagePlanAssignBranch?search=${search}`, requestOptions).then(handleResponse);
    // }
    // else{
    //     return fetch(`${config.apiUrl}/OutBound/getVoyageListingStowagePlanAssignBranch`, requestOptions).then(handleResponse);
    // }
    if(search){
        return fetch(`${config.apiUrl}/OutBound/getVoyageListingStowagePlanAssignBranchV1?search=${search}`, requestOptions).then(handleResponse);
    }
    else{
        return fetch(`${config.apiUrl}/OutBound/getVoyageListingStowagePlanAssignBranchV1`, requestOptions).then(handleResponse);
    }
    // const requestOptions = {
    //     method: 'GET'
    // };
    // if (branchCode) return fetch(`${config.apiUrl}/OutBound/getVoyageStowagePlanList?branchCode=${branchCode}`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/OutBound/getVoyageStowagePlanList`, requestOptions).then(handleResponse);
    // if (branchCode){
    //     if(search){
    //         return fetch(`${config.apiUrl}/OutBound/getVoyageListingStowagePlan?branchCode=${branchCode}&search=${search}`, requestOptions).then(handleResponse);
    //     } 
    //     else{
    //         return fetch(`${config.apiUrl}/OutBound/getVoyageListingStowagePlan?branchCode=${branchCode}`, requestOptions).then(handleResponse);
    //     }
    // }
    // else{
    //     if(search){
    //         return fetch(`${config.apiUrl}/OutBound/getVoyageListingStowagePlan?search=${search}`, requestOptions).then(handleResponse);
    //     }
    //     else{
    //         return fetch(`${config.apiUrl}/OutBound/getVoyageListingStowagePlan`, requestOptions).then(handleResponse);
    //     }
    // }
}
function getVoyageLoadingConfirmationList(branchCode, search) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(branchCode),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    // if(search){
    //     return fetch(`${config.apiUrl}/OutBound/getVoyageListingLoadingConfirmationAssignBranch?search=${search}`, requestOptions).then(handleResponse);
    // }
    // else{
    //     return fetch(`${config.apiUrl}/OutBound/getVoyageListingLoadingConfirmationAssignBranch`, requestOptions).then(handleResponse);
    // }
    if(search){
        return fetch(`${config.apiUrl}/OutBound/getVoyageListingLoadingConfirmationAssignBranchV1?search=${search}`, requestOptions).then(handleResponse);
    }
    else{
        return fetch(`${config.apiUrl}/OutBound/getVoyageListingLoadingConfirmationAssignBranchV1`, requestOptions).then(handleResponse);
    }
    // const requestOptions = {
    //     method: 'GET'
    // };
    // if (branchCode) return fetch(`${config.apiUrl}/OutBound/getVoyageLoadingConfirmationList?branchCode=${branchCode}`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/OutBound/getVoyageLoadingConfirmationList`, requestOptions).then(handleResponse);
    // if (branchCode) {
    //     if(search){
    //         return fetch(`${config.apiUrl}/OutBound/getVoyageListingLoadingConfirmation?branchCode=${branchCode}&search=${search}`, requestOptions).then(handleResponse);
    //     }
    //     else{
    //         return fetch(`${config.apiUrl}/OutBound/getVoyageListingLoadingConfirmation?branchCode=${branchCode}`, requestOptions).then(handleResponse);            
    //     }
    // }
    // else{
    //     if(search){
    //         return fetch(`${config.apiUrl}/OutBound/getVoyageListingLoadingConfirmation?search=${search}`, requestOptions).then(handleResponse);
    //     }
    //     else{
    //         return fetch(`${config.apiUrl}/OutBound/getVoyageListingLoadingConfirmation`, requestOptions).then(handleResponse);
    //     }
    // }
}
function getVoyageWayBill(branchCode) {
    const requestOptions = {
        method: 'GET'
    };
    // return fetch(`${config.apiUrl}/OutBound/getVoyageWayBill?branchCode=${branchCode}`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/OutBound/getVoyageListingWayBill?branchCode=${branchCode}`, requestOptions).then(handleResponse);
}
function getVoyageForReguidingList(branchCode, search) {
    const requestOptions = {
        method: 'GET'
    };
    // if (branchCode) return fetch(`${config.apiUrl}/OutBound/getVoyageForReguidingList?branchCode=${branchCode}`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/OutBound/getVoyageForReguidingList`, requestOptions).then(handleResponse);
    // if (branchCode) {
    //     if(search){
    //         return fetch(`${config.apiUrl}/OutBound/getVoyageListingForReguiding?branchCode=${branchCode}&search=${search}`, requestOptions).then(handleResponse);
    //     }
    //     else{
    //         return fetch(`${config.apiUrl}/OutBound/getVoyageListingForReguiding?branchCode=${branchCode}`, requestOptions).then(handleResponse);   
    //     }
    // }
    // else{
    //     if(search){
    //         return fetch(`${config.apiUrl}/OutBound/getVoyageListingForReguiding?search=${search}`, requestOptions).then(handleResponse);
    //     }
    //     else{
    //         return fetch(`${config.apiUrl}/OutBound/getVoyageListingForReguiding`, requestOptions).then(handleResponse);
    //     }
    // }
    if (branchCode) {
        if(search){
            return fetch(`${config.apiUrl}/OutBound/getVoyageListingForReguidingV1?branchCode=${branchCode}&search=${search}`, requestOptions).then(handleResponse);
        }
        else{
            return fetch(`${config.apiUrl}/OutBound/getVoyageListingForReguidingV1?branchCode=${branchCode}`, requestOptions).then(handleResponse);   
        }
    }
    else{
        if(search){
            return fetch(`${config.apiUrl}/OutBound/getVoyageListingForReguidingV1?search=${search}`, requestOptions).then(handleResponse);
        }
        else{
            return fetch(`${config.apiUrl}/OutBound/getVoyageListingForReguidingV1`, requestOptions).then(handleResponse);
        }
    }
}

// Reguide
function getReguideVoyage(voyageNum, search) {
    // const requestOptions = {
    //     method: 'GET'
    // };
    var requestOptions;
    if (search) {
        requestOptions = {
            method: 'POST',
            body: JSON.stringify(search),
            headers: {
                "Content-type": "application/json; charset=UTF-8"
            }
        };
    }
    else {
        requestOptions = {
            method: 'POST',
            body: JSON.stringify([]),
            headers: {
                "Content-type": "application/json; charset=UTF-8"
            }
        };
    }
    // if (search) {
    //     return fetch(`${config.apiUrl}/OutBound/getReguideVoyage/${voyageNum}?search=${search}`, requestOptions).then(handleResponse);
    // }
    // else {
    //     return fetch(`${config.apiUrl}/OutBound/getReguideVoyage/${voyageNum}`, requestOptions).then(handleResponse);
    // }
    return fetch(`${config.apiUrl}/OutBound/getReguideVoyage?voyageNUm=${voyageNum}`, requestOptions).then(handleResponse);
}
function getVoyageScheduleForReguiding(data) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/OutBound/getVoyageScheduleForReguiding`, requestOptions).then(handleResponse);
}
function changeVessel(payload, voyageNum) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/OutBound/changeVessel/${voyageNum}`, requestOptions).then(handleResponse);
}
function voyageTransfer(payload) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/OutBound/voyageTransfer`, requestOptions).then(handleResponse);
}
// CRO Accounting
function getVoyageCroAccounting() {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/OutBound/getVoyageCroAccounting`, requestOptions).then(handleResponse);
}
function getWayBIllWithDemmurage(voyageNum) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/OutBound/getWayBIllWithDemmurage/${voyageNum}`, requestOptions).then(handleResponse);
}
function getWayBIllCROAccounting(voyageNum) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/OutBound/getWayBIllCROAccounting/${voyageNum}`, requestOptions).then(handleResponse);
}
function getWayBIllRefCROAccounting(WayBillRef) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/OutBound/getWayBIllRefCROAccounting/${WayBillRef}`, requestOptions).then(handleResponse);
}
function updateCroAccounting(wayBillRef, payload) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/OutBound/updateCroAccounting/${wayBillRef}`, requestOptions).then(handleResponse);
}

function getPrevVoyage(voyageNum) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/OutBound/getPrevVoyage/${voyageNum}`, requestOptions).then(handleResponse);
}